module.exports = __webpack_public_path__ + "media/country_flags/in-ec1b15dc.png";